import Common from "../../Common";
import Extend from "./verify/Extend";

const Verify = class extends Common {
	extend: InstanceType<typeof Extend>;

	constructor(headers: ApiHeaders) {
		super(headers)

		this.extend = new Extend(headers);
	}
}

export default Verify
